export default {
  'setOwnerCutPerMillion(uint256)': 'Set fees to `@formatPct($1, 1000000)`%',
  'transferMarketplaceOwnership(address)':
    'Transfer ownership of the marketplace to `$1`',
  'transferOwnership(address)': 'Transfer ownership of the contract to `$1`',
  'pause()': 'Pause contract',
  'unpause()': 'Unpause Contract`'
}
